// src/components/LoadingSpinner.js
import React from 'react';

const spinnerStyle = {
  textAlign: 'center',
  padding: '80px 20px',
  fontSize: '1rem',
  fontWeight: 400,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '400px'
};

const animationStyle = `
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  .spinner-circle {
    width: 50px;
    height: 50px;
    border: 3px solid #e5e5e5;
    border-top: 3px solid #0066cc;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 1rem;
  }
`;

const LoadingSpinner = () => (
  <>
    <style>{animationStyle}</style>
    <div style={spinnerStyle}>
      <div className="spinner-circle"></div>
      <p style={{ color: '#5f6368', marginTop: '0.5rem', letterSpacing: '0.5px' }}>
        Loading...
      </p>
    </div>
  </>
);

export default LoadingSpinner;
